<template>
    <BaseInsuranceSuccess
      :link="ramadanIsActive ? null : link"
      :email="email"
      :locale="locale"
      :loading="loading"
      :receipt="ramadanIsActive ? null : receipt"
      :error="errorMessage"
      :whoWillWin="whoWillWin"
      :img="getImage()"
      :qdApp="isQdApp">
      <template #info>
        <RamadanBanner v-if="ramadanIsActive" :link="link" :receipt-link="receipt" />
      </template>
    </BaseInsuranceSuccess>
</template>

<script>
import { BaseInsuranceSuccess } from 'qic-components'
import { trackGtag } from '@/utils/useGtag'
import { getErrorMessage } from '@/shared/errors/getErrorMessage'
import RamadanBanner from '@/components/campaigns/Ramadan/ui/RamadanBanner.vue'
import { mapState } from 'vuex'

export default {
  name: 'PaymentInsuranceSuccess',
  components: {
    RamadanBanner,
    BaseInsuranceSuccess
  },
  data () {
    return {
      email: '',
      link: null,
      errorMessage: null,
      loading: false,
      receipt: null,
      productType: this.$store.state.renew.productType || '',
      whoWillWin: false,
      eventData: null
    }
  },
  computed: {
    ...mapState({
      ramadanIsActive: state => state.ramadan.ramadanIsActive
    }),
    isQdApp () {
      const prodCode = JSON.parse(localStorage.getItem('qic_renew'))?.policyInfo?.prodCode.toString()
      return prodCode === '0100' || prodCode === '0110'
    },
    savedLocale () {
      return this.$store.getters.savedLocale
    },
    locale () {
      return this.$i18n.locale
    }
  },
  methods: {
    loadPolicy () {
      this.loading = true
      Promise.all([
        this.$store.dispatch('getPolicy'),
        this.$store.dispatch('getInsuranceEmail')
      ])
        .then(([policy, email]) => {
          this.$store.commit('setMotorPromocode', '')
          this.$store.commit('setPromocode', '')
          this.whoWillWin = policy?.showpromo
          this.link = policy.link
          this.email = email
          this.receipt = policy.receiptlink
        })
        .catch((error) => {
          this.errorMessage = getErrorMessage(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    getImage () {
      return this.productType ? require(`@/assets/images/insurance/${this.productType}.png`) : ''
    },
    loadEventDataFromLocalStorage () {
      const eventDataFromLocalStorage = JSON.parse(localStorage.getItem('eventData'))
      const paymentMethodUpdate = localStorage.getItem('paymentMethod')

      if (eventDataFromLocalStorage) {
        if (paymentMethodUpdate) {
          eventDataFromLocalStorage.choosen_card = paymentMethodUpdate
        }

        this.eventData = eventDataFromLocalStorage
        trackGtag('purchase', this.eventData)
      }
    }
  },
  mounted () {
    this.loading = true
    setTimeout(() => {
      this.loadEventDataFromLocalStorage()
      return this.loadPolicy()
    }, 1000)
  }
}
</script>
